import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  TextField,
  Typography,
  Alert,
  AlertTitle,
  Divider,
  Paper
} from '@mui/material';
import { Email as EmailIcon, Unsubscribe as UnsubscribeIcon } from '@mui/icons-material';
import { unsubscribeEmail } from '../../../network/apis/file.api';
import UnsubscribeFormStyles from '../../../styles/UnsubscribeForm.module.css';
import { useParams } from 'react-router-dom';

const UnsubscribePage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get('userId');
  const email = decodeURIComponent(urlParams.get('email')); 
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    const response = await unsubscribeEmail(email, userId);
    setResult({
      success: true,
      message: response.message,
      email: response.email,
      status: response.status,
      recipientId: response.recipientId
    });
  } catch (error) {
    let errorMessage = 'An unexpected error occurred';
    
    // Handle 403 Forbidden error specifically
    if (error.response?.status === 403) {
      errorMessage = 'Invalid unsubscribe link. You are not authorized to unsubscribe this email.';
    } 
    // Handle 400 Bad Request (missing fields)
    else if (error.response?.status === 400) {
      errorMessage = error.response.data?.message || 'Both email and recipient ID are required';
    }
    // Handle 404 Not Found
    else if (error.response?.status === 404) {
      errorMessage = 'Email not found in our system';
    }
    // Handle network errors or other exceptions
    else if (error.message) {
      errorMessage = error.message;
    }

    setResult({
      success: false,
      message: errorMessage
    });
  } finally {
    setLoading(false);
  }
};

  return (
   <Container maxWidth="sm" className={UnsubscribeFormStyles.container}>
  <Paper elevation={3} className={UnsubscribeFormStyles.paper}>
    <Box className={UnsubscribeFormStyles.header}>
      <UnsubscribeIcon className={UnsubscribeFormStyles.headerIcon} />
      <Typography variant="h3" component="h1" gutterBottom className={UnsubscribeFormStyles.title}>
        Email Unsubscription
      </Typography>
      <Typography variant="h6" className={UnsubscribeFormStyles.subtitle}>
        We're sorry to see you go. Please enter your email address to unsubscribe.
      </Typography>
    </Box>

    <CardContent className={UnsubscribeFormStyles.cardContent}>
      {result ? (
        <Box className={UnsubscribeFormStyles.resultContainer}>
          <Alert
            severity={result.success ? 'success' : 'error'}
            className={UnsubscribeFormStyles.alert}
          >
            <AlertTitle className={UnsubscribeFormStyles.alertTitle}>
              {result.success ? 'Unsubscription Successful' : 'Error'}
            </AlertTitle>
            {result.message}
            {result.email && (
              <>
                <Divider className={UnsubscribeFormStyles.divider} />
                <Typography variant="body1" className={UnsubscribeFormStyles.emailInfo}>
                  Email: <strong>{result.email}</strong>
                </Typography>
                <Typography variant="body1" className={UnsubscribeFormStyles.emailInfo}>
                  Status: <strong>{result.status}</strong>
                </Typography>
              </>
            )}
          </Alert>

          {result.success && (
            <Box className={UnsubscribeFormStyles.successMessage}>
              <Typography variant="body1" className={UnsubscribeFormStyles.successText}>
                You won't receive any further emails from us.
              </Typography>
            </Box>
          )}

          {/* <Button
            variant="contained"
            fullWidth
            className={`${UnsubscribeFormStyles.button} ${result.success ? '' : UnsubscribeFormStyles.tryAgainButton}`}
            onClick={() => {
              setResult(null);
            }}
          >
            {result.success ? 'Unsubscribe Another Email' : 'Try Again'}
          </Button> */}
        </Box>
      ) : (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} className={UnsubscribeFormStyles.formGrid}>
            {/* <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                type="email"
                value={email}
                required
                InputProps={{
                  startAdornment: (
                    <EmailIcon className={UnsubscribeFormStyles.emailIcon} />
                  ),
                }}
                InputLabelProps={{
                  className: UnsubscribeFormStyles.textFieldLabel
                }}
                inputProps={{
                  className: UnsubscribeFormStyles.textField
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={loading || !email}
                className={`${UnsubscribeFormStyles.button} ${(loading || !email) ? UnsubscribeFormStyles.disabledButton : ''}`}
                startIcon={
                  loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    <UnsubscribeIcon fontSize="small" />
                  )
                }
              >
                {loading ? 'Processing...' : 'Unsubscribe'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={UnsubscribeFormStyles.footerText}>
                By unsubscribing, you'll no longer receive any email notifications from our service.
              </Typography>
            </Grid>
          </Grid>
        </form>
      )}
    </CardContent>
  </Paper>
</Container>
  );
};

export default UnsubscribePage;